import { getRecommendedRegisteredBlocks } from './blocks/recommended.js';
import { applyQuery, UserLocalStorage } from './utils/index.js';
export class SlateKit {
    constructor(intl, options) {
        this.registeredBlocks = {};
        const { userStorage, blocks, slateWrapper, blockWrapper, useRecommendedBlocks, } = options || {};
        this.setUserStorage(userStorage || new UserLocalStorage());
        if (useRecommendedBlocks !== false) {
            this.registerBlocks(getRecommendedRegisteredBlocks(intl));
        }
        if (blocks) {
            this.registerBlocks(blocks);
        }
        if (slateWrapper) {
            this.registerSlateWrapper(slateWrapper);
        }
        if (blockWrapper) {
            this.registerBlockWrapper(blockWrapper);
        }
    }
    isBlockRegistered(name) {
        return !!this.registeredBlocks[name];
    }
    registerBlockWrapper(wrapper) {
        this.BlockWrapper = wrapper;
    }
    loadBlockWrapper() {
        if (!this.BlockWrapper) {
            return null;
        }
        return this.BlockWrapper;
    }
    registerSlateWrapper(wrapper) {
        this.SlateWrapper = wrapper;
    }
    loadSlateWrapper() {
        if (!this.SlateWrapper) {
            return null;
        }
        return this.SlateWrapper;
    }
    registerBlocks(blocks) {
        Object.keys(blocks).forEach(name => this.registerBlock(name, blocks[name]));
    }
    registerBlock(name, registeredBlock) {
        this.registeredBlocks[name] = Object.assign(Object.assign({ name }, registeredBlock), { config: Object.assign(Object.assign({ displayName: name, acceptsChildren: false, deprecated: false, hide: false, lockedChildren: false, removable: true, states: [], usable: false }, registeredBlock.config), { availabilityConditions: Object.assign({ header: false }, (registeredBlock.config.availabilityConditions || {})), editable: registeredBlock.config.editable !== false &&
                    !!registeredBlock.config.Settings }) });
    }
    getRegisteredBlock(name) {
        return this.registeredBlocks[name];
    }
    getAvailableBlocks(options) {
        const { context, filter, orderBy } = options;
        const result = Object.values(this.registeredBlocks)
            .filter(block => {
            const { config: { availabilityConditions }, } = block;
            return applyQuery(context, availabilityConditions);
        })
            .filter(block => {
            return applyQuery(block.config, filter);
        });
        if (orderBy) {
            const orderBys = Array.isArray(orderBy) ? orderBy : [orderBy];
            result.sort((a, b) => {
                const order = orderBys
                    .map(orderBy => {
                    if (a.config[orderBy] < b.config[orderBy]) {
                        return -1;
                    }
                    if (a.config[orderBy] > b.config[orderBy]) {
                        return 1;
                    }
                    return 0;
                })
                    .find(result => result !== 0);
                return order || 0;
            });
        }
        return result;
    }
    getDynamicBlock() {
        return this.registeredBlocks.DynamicBlock;
    }
    setUserStorage(storage) {
        this.userStorage = storage;
    }
}
//# sourceMappingURL=slate-kit.js.map